import { Vue, Component, Prop } from 'vue-property-decorator';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import couponCard from '@/views/components/couponsManager/couponCard';

@DialogFactory
@Component({
  components: { couponCard },
})
export default class EnableCouponsList extends IPSDialog {
  title = '可用券列表';

  confirm = false;

  dataList = [];

  productId = 0;

  siteId = 0;

  width = '650px';

  mounted() {
    this.productId && this.getData();
  }

  getData() {
    IPSService.siteProductCouponList({
      postParams: {
        productId: this.productId,
        siteId: this.siteId,
      },
    }).then((response) => {
      this.dataList = (response.list || []).map((v) => {
        v = Object.assign({}, v, { isAll: v.receiptConfig.isAllReceipt });
        return v;
      });
      const allRequest = this.dataList
        .filter(v => !!v.receiptConfig.memberTagConfig)
        .map((val) => {
          return this.getConditionText(val.receiptConfig.memberTagConfig);
        });
      Promise.all(allRequest).then((result) => {
        result.forEach((v) => {
          const findCouponIndex = this.dataList.findIndex(vl => vl.receiptConfig.memberTagConfig === v.id);
          if (findCouponIndex !== -1) {
            let length = 0;
            (v.conditions || []).forEach((val) => {
              const orLength = val.or ? val.or.length : 0;
              const andLength = val.and ? val.and.length : 0;
              length = length + orLength + andLength;
            });
            this.dataList[findCouponIndex] = Object.assign({}, this.dataList[findCouponIndex], {
              condition: length,
              id: v.id,
            });
          }
        });
        this.$forceUpdate();
      });
    });
  }

  getConditionText(id) {
    return IPSService.customerCondition({
      queryParams: {
        id,
        EXT_IPS__SITE: this.siteId,
      },
    });
  }

  renderContent(h) {
    return (
      <div class="hei-175">
        {this.dataList.map((v, i) => {
          return <couponCard data={v} key={i} class="r-my-12 r-mx-auto" couponIndex={i + 1} siteId={this.siteId} />;
        })}
      </div>
    );
  }
}
